import React from 'react'

const User = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/user',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <path
      d='M6.5 5.5C6.5 3.556 8.081 2 10 2s3.5 1.556 3.5 3.5C13.5 7.419 11.944 9 10 9c-1.919-.026-3.5-1.581-3.5-3.5zM10 10c-3.304 0-6 3.947-6 5.573 0 1.627 2.696 2.08 6 2.08s6-.453 6-2.08C16 13.947 13.304 10 10 10z'
      fill={primaryColor}
      fillRule='nonzero'
    />
  </svg>
)

export default User
